// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"574fe3bf","339":"74e5748e","484":"1bef058b","551":"f08f88f6","640":"11126420","672":"8c930295","842":"8df647c5","869":"d1c6690c","902":"5ddf75e0","940":"c568d512","974":"2be7b50c"}[chunkId] + ".chunk.js";
};